import { ObservableDataSource } from '../observable/observable-data-source';

function getKeyOfReport(report) {
  const { Id = 0, ReportType } = report;
  return `${Id}-${ReportType}`;
}

class LoadingReportsStore {
  constructor() {
    this.reportsMap = new Map();
  }

  get() {
    return Array.from(this.reportsMap.values());
  }

  add(report) {
    const key = getKeyOfReport(report);
    this.reportsMap.set(key, report);
  }

  remove(report) {
    const key = getKeyOfReport(report);
    this.reportsMap.delete(key);
  }
}

export const loadingReportsStore = new LoadingReportsStore();


export const loadingReportsDataSource = new ObservableDataSource({
  makeCall: () => Promise.resolve(loadingReportsStore.get()),
});
